import { useNavigation } from '@react-navigation/native';
import ParkingContext from 'context/ParkingContext';
import useParkingPricingInfo from 'hooks/useParkingPricingInfo';
import useReadPurchasedPrepaidTickets from 'hooks/useReadPurchasedPrepaidTickets';
import React, { useContext, useEffect } from 'react';
import { ParkNavProps } from 'types/navigation';
import PrepaidTickets from './detail/PrepaidTickets';

const ParkingPrepaidTickets = ({
  borderTop,
  showTicketsCallback,
}: {
  borderTop?: boolean;
  showTicketsCallback?: (show: boolean) => void;
}) => {
  const { parkingZoneResult, mySalesOrdersForZone, availablePermits } =
    useContext(ParkingContext);
  const uid = parkingZoneResult?.data?.parkZone?.uid as string;
  const { purchasedPrepaidTickets } = useReadPurchasedPrepaidTickets({});
  const { navigate: navigatePark } = useNavigation<ParkNavProps>();
  const isUnmanagedParking =
    parkingZoneResult?.data?.parkZone?.parkingMethods?.unmanagedParking ===
    true;
  const { predefinedTickets } = useParkingPricingInfo(
    uid,
    true,
    isUnmanagedParking
  );
  const prepaidTickets = predefinedTickets.filter(
    (predefinedTicket) =>
      predefinedTicket?.sessionType === 'PREPAID' &&
      predefinedTicket.duration &&
      predefinedTicket.duration !== ''
  );

  const handlePrepaidAndPermitListPress = () => {
    navigatePark('parkPrepaidTicketsAndPermitsList', {
      parkingZoneUid: uid,
    });
  };

  const purchasedTickets = [
    ...(mySalesOrdersForZone ?? []),
    ...purchasedPrepaidTickets,
  ];
  const purchasedAndPurchaseableTickets = [
    ...purchasedTickets,
    ...prepaidTickets,
    ...(availablePermits ?? []),
  ];

  useEffect(
    () => showTicketsCallback?.(purchasedAndPurchaseableTickets.length > 0),
    [purchasedAndPurchaseableTickets]
  );

  if (purchasedAndPurchaseableTickets.length > 0) {
    return (
      <PrepaidTickets
        onListPress={handlePrepaidAndPermitListPress}
        testID="prepaid-tickets-listing"
        borderTop={borderTop}
        ownedTickets={purchasedTickets.length}
      />
    );
  }
  return <></>;
};

export default ParkingPrepaidTickets;
